import { apiClient } from "./client";

const GetAll = () => {
  return apiClient
    .get("/Hotel");
}

const GetByKey = (id) => {
  return apiClient
    .get("/Hotel/GetById", {
      params: {
        'key': id
      }
    });
}

const HotelDropDown = (cityConsistency) => {
  return apiClient
    .get("/Hotel/HotelDropDown", {
      params: {
        'cityConsistency': cityConsistency
      }
    });
}

const PlanCodeHotelDropDown = (hotelId) => {
  return apiClient
    .get("/Hotel/PlanCodeHotelDropDown", {
      params: {
        'HotelId': hotelId
      }
    });
}

const CompanyHotelDropDown = (hotelId) => {
  return apiClient
    .get("/Hotel/CompanyHotelDropDown", {
      params: {
        'HotelId': hotelId
      }
    });
}

const GetForUser = (cityConsistency, hotelId, isActive) => {
  return apiClient
    .post("/Hotel/GetForUser", {
      "cityConsistency": cityConsistency,
      "hotelId": hotelId,
      "isActive": isActive
    });
}

const SoftDelete = (id) => {
  return apiClient
    .delete("/Hotel", {
      params: {
        'Id': id
      }
    });
}
const Add = (formData) => {
  return apiClient.post('/Hotel', formData)
}

const Update = (data) => {
  return apiClient.put('/Hotel', {
    "name": data.name,
    "address": data.address,
    "arabianAddress": data.arabianAddress,
    "cityConsistency": data.cityConsistency,
    "description": data.description,
    "companyInfo": data.companyInfo,
    "priceGroup": data.priceGroup,
    "region": data.region,
    "isActive": data.isActive,
    "managerName": data.managerName,
    "managerPhoneNumber": data.managerPhoneNumber,
    "phoneNumber": data.phoneNumber
  }, {
    params: {
      'id': data.id
    }
  }
  )
}
const hotelApi = { Add, Update, GetAll, GetByKey, HotelDropDown, GetForUser, CompanyHotelDropDown, PlanCodeHotelDropDown, SoftDelete }
export default hotelApi;